import React from 'react';
import { Facebook, Instagram, Youtube, Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img
                src="/assets/logo.jpg"
                alt="Marhaban Tour & Travel"
                className="h-14 w-auto rounded-lg shadow-md"
              />
              <div>
                <div className="text-lg font-bold text-white">{companyInfo.name}</div>
              </div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Mitra terpercaya perjalanan ibadah umroh Anda. Berpengalaman lebih dari 10 tahun melayani ribuan jamaah ke tanah suci.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#8B0000] rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#8B0000] rounded-lg flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#8B0000] rounded-lg flex items-center justify-center transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Menu Cepat</h3>
            <ul className="space-y-3">
              {['Beranda', 'Paket Umroh', 'Fasilitas', 'Galeri', 'Testimoni', 'Kontak'].map((item) => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase().replace(' ', '-')}`}
                    className="text-gray-400 hover:text-[#F5C842] transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Packages */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Paket Populer</h3>
            <ul className="space-y-3">
              <li>
                <a href="#packages" className="text-gray-400 hover:text-[#F5C842] transition-colors">
                  Umroh Plus Mesir
                </a>
              </li>
              <li>
                <a href="#packages" className="text-gray-400 hover:text-[#F5C842] transition-colors">
                  Umroh Ramadhan
                </a>
              </li>
              <li>
                <a href="#packages" className="text-gray-400 hover:text-[#F5C842] transition-colors">
                  Umroh Reguler
                </a>
              </li>
              <li>
                <a href="#packages" className="text-gray-400 hover:text-[#F5C842] transition-colors">
                  Umroh Plus Turki
                </a>
              </li>
              <li>
                <a href="#packages" className="text-gray-400 hover:text-[#F5C842] transition-colors">
                  Umroh Haji Plus
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Hubungi Kami</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#F5C842] mt-0.5 flex-shrink-0" />
                <span className="text-gray-400">{companyInfo.address}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-[#F5C842] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-400">{companyInfo.contactPerson}</p>
                  <a href={`tel:${companyInfo.phone}`} className="text-[#F5C842] hover:underline">
                    {companyInfo.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-[#F5C842] mt-0.5 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-gray-400 hover:text-[#F5C842] transition-colors">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#F5C842] transition-colors">
                Syarat & Ketentuan
              </a>
              <a href="#" className="text-gray-400 hover:text-[#F5C842] transition-colors">
                Kebijakan Privasi
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
